// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"5a144669","488":"6088df31"}[chunkId] + ".chunk.js";
};